var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgSurveyManagementIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.684 35.26c-.003.582-.273.993-.707 1.187l-.69.316c-2.361-.771-1.485-9.938-1.63-12.543l.727-13.674c-.61-.817-2.957-1.528-2.409-3.195L14.052 4.87c-.308-.16-8.388-3.743-6.937-4.414.241-.113.48-.226.722-.332.536-.242 1.219-.092 1.72.129l13.777 6.05c1.353.598 2.413 2.04 2.41 3.194l-.059 25.763Z",
    fill: "#2E2E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.408 1.64c.002-.57.26-.977.679-1.174.441-.208 1.06-.186 1.746.117L22.61 6.632c1.333.59 2.413 2.021 2.409 3.194l-.058 25.763c-.004 1.174-1.09 1.647-2.424 1.058L8.76 30.597c-1.335-.59-2.414-2.021-2.41-3.194l.058-25.762Z",
    fill: "#2E2E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.148 2.749c.003-1.08 1.002-1.517 2.232-.973l12.68 5.567c1.228.543 2.22 1.861 2.217 2.94l-.052 24.2c-.003 1.08-1.004 1.516-2.232.974l-12.682-5.57c-1.228-.543-2.22-1.859-2.217-2.939l.054-24.2Z",
    fill: "url(#survey-management-icon_svg__a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.494 16.085c.002-.185.173-.26.383-.166 2.237.981 9.632 4.26 11.868 5.243.211.093.381.32.381.504l.012 6.78c0 .184-.174.26-.383.166-2.237-.983-9.632-4.26-11.868-5.242-.212-.093-.382-.32-.382-.506l-.01-6.779Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87 16.39c0-.048.045-.069.1-.043.587.258 1.173.525 1.761.783.056.024.1.084.1.133l.003 1.78c0 .049-.046.068-.101.044-.588-.258-1.174-.526-1.762-.784-.056-.024-.1-.083-.1-.132l-.002-1.78ZM12.34 17.454c0-.049.046-.068.101-.044.588.258 1.175.525 1.762.783.056.024.1.084.1.133l.003 1.78c0 .049-.044.068-.1.044-.587-.258-1.173-.525-1.76-.783-.055-.025-.1-.084-.1-.133l-.006-1.78ZM14.815 18.563c0-.049.046-.068.1-.044.587.258 1.174.525 1.761.783.056.025.1.084.1.133l.003 1.782c0 .048-.046.068-.1.043-.587-.258-1.173-.525-1.761-.783-.056-.024-.1-.084-.1-.133l-.003-1.781ZM17.287 19.648c0-.05.046-.069.1-.044.588.258 1.174.525 1.762.783.055.024.1.084.1.133l.003 1.78c0 .049-.046.068-.1.044-.588-.258-1.175-.526-1.762-.783-.055-.025-.1-.084-.1-.133l-.003-1.78ZM19.76 20.714c0-.048.046-.068.1-.044.588.258 1.174.526 1.762.784.055.024.1.084.1.132l.003 1.78c0 .05-.046.069-.1.044-.588-.257-1.174-.525-1.762-.783-.056-.024-.1-.084-.1-.132l-.003-1.78ZM9.87 18.806c0-.049.045-.068.1-.044.587.258 1.173.526 1.761.783.056.025.1.084.1.133l.003 1.78c0 .05-.046.07-.101.044-.588-.258-1.174-.525-1.762-.783-.056-.024-.1-.084-.1-.133l-.002-1.78ZM12.34 19.87c0-.048.046-.068.101-.043.588.257 1.175.525 1.762.783.056.024.1.084.1.132l.003 1.78c0 .05-.044.069-.1.045-.587-.258-1.173-.526-1.76-.784-.055-.024-.1-.083-.1-.132l-.006-1.78ZM14.815 20.978c0-.048.046-.068.1-.044.587.258 1.174.526 1.761.784.056.024.1.084.1.132l.003 1.78c0 .05-.046.069-.1.045-.587-.258-1.173-.526-1.761-.784-.056-.024-.1-.083-.1-.132l-.003-1.78ZM17.287 22.064c0-.048.046-.068.1-.044.588.258 1.174.526 1.762.784.055.024.1.084.1.132l.003 1.78c0 .05-.046.069-.1.044-.588-.257-1.175-.525-1.762-.783-.055-.024-.1-.084-.1-.132l-.003-1.78ZM19.76 23.13c0-.048.046-.067.1-.043.588.258 1.174.526 1.762.783.055.025.1.084.1.133l.003 1.78c0 .05-.046.069-.1.044-.588-.258-1.174-.525-1.762-.783-.056-.024-.1-.084-.1-.133l-.003-1.78ZM9.87 21.223c0-.049.045-.068.1-.044.587.258 1.173.525 1.761.783.056.024.1.084.1.133l.003 1.78c0 .049-.046.068-.101.044-.588-.258-1.174-.525-1.762-.783-.056-.025-.1-.084-.1-.133l-.002-1.78ZM12.34 22.286c0-.049.046-.068.101-.044.588.258 1.175.526 1.762.783.056.025.1.084.1.133l.003 1.78c0 .05-.044.069-.1.044-.587-.258-1.173-.525-1.76-.783-.055-.024-.1-.084-.1-.133l-.006-1.78ZM14.815 23.395c0-.049.046-.068.1-.044.587.258 1.174.525 1.761.783.056.025.1.084.1.133l.003 1.78c0 .049-.046.068-.1.044-.587-.258-1.173-.525-1.761-.783-.056-.024-.1-.084-.1-.133l-.003-1.78ZM17.287 24.481c0-.049.046-.068.1-.044.588.258 1.174.526 1.762.784.055.024.1.083.1.132l.003 1.78c0 .05-.046.069-.1.044-.588-.258-1.175-.525-1.762-.783-.055-.024-.1-.084-.1-.132l-.003-1.781ZM19.76 25.546c0-.048.046-.068.1-.044.588.258 1.174.526 1.762.784.055.024.1.084.1.132l.003 1.78c0 .05-.046.069-.1.044-.588-.257-1.174-.525-1.762-.783-.056-.024-.1-.084-.1-.132l-.003-1.78Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.479 5.211c0-.256.238-.36.529-.23 3.086 1.354 10.52 4.71 13.606 6.066.29.128.526.441.526.696l.015 9.353c-.001.257-.238.36-.529.231-3.086-1.355-10.52-4.71-13.606-6.066-.29-.13-.526-.442-.526-.697L8.48 5.21Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.854 5.865c0-.12.112-.168.249-.106l3.106 1.344c.138.062.247.211.247.332v.24c0 .12-.112.167-.249.105L9.101 6.436c-.138-.063-.247-.211-.247-.332v-.24ZM8.854 6.913c0-.107.098-.148.219-.094 1.76.763 4.646 2.006 6.408 2.767.12.055.22.186.22.293v.21c0 .108-.1.149-.222.094-1.76-.762-4.646-2.005-6.406-2.767-.121-.054-.22-.186-.218-.291v-.212h-.001ZM8.82 8.796c0-.135.126-.189.28-.118 4.446 1.924 8.904 3.833 13.352 5.757.154.07.278.237.278.372v.268c0 .135-.126.188-.28.118-4.446-1.923-8.904-3.834-13.35-5.758-.154-.07-.278-.237-.278-.372v-.267H8.82ZM8.82 10.214c0-.135.126-.189.28-.12 4.446 1.925 8.904 3.834 13.352 5.758.154.07.278.237.278.372v.268c0 .136-.126.188-.28.118-4.446-1.924-8.904-3.833-13.35-5.758-.154-.069-.278-.237-.278-.372v-.266H8.82ZM8.82 11.632c0-.135.126-.189.28-.118 4.446 1.924 8.904 3.833 13.352 5.757.154.07.278.237.278.372v.268c0 .135-.126.188-.28.118-4.446-1.924-8.904-3.834-13.35-5.758-.154-.07-.278-.237-.278-.372v-.267H8.82ZM8.82 13.05c0-.136.126-.19.28-.12l4.855 2.141c.154.07.278.237.278.372v.268c0 .135-.126.188-.28.118l-4.855-2.14c-.154-.071-.278-.238-.278-.373v-.266Z",
    fill: "#00AF9B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.939 25.403c-.709-.313-1.287-.061-1.289.562-.001.621.572 1.383 1.28 1.696.706.313 1.284.06 1.287-.562.002-.622-.571-1.384-1.278-1.696Z",
    fill: "#FFDB69"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.424 26.231c.146.064.265.013.265-.114 0-.128-.117-.285-.264-.35-.146-.065-.263-.013-.265.115 0 .128.118.284.264.349ZM13.442 27.133c-.028-.012-.055-.014-.078-.005a.406.406 0 0 1-.197.036.704.704 0 0 1-.235-.062 1.021 1.021 0 0 1-.236-.148 1.196 1.196 0 0 1-.197-.209.196.196 0 0 0-.077-.064.104.104 0 0 0-.073-.008c-.044.016-.046.075-.006.132a1.499 1.499 0 0 0 .59.486c.112.05.22.076.317.083a.529.529 0 0 0 .268-.047c.042-.02.039-.08-.003-.133a.179.179 0 0 0-.073-.06ZM13.445 26.218c-.146-.065-.264-.013-.265.115 0 .128.117.285.263.35.145.064.266.011.266-.116 0-.128-.118-.285-.264-.35Z",
    fill: "#3E4992"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.787 26.662c-.706-.313-1.284-.06-1.287.563-.002.621.572 1.383 1.279 1.695.708.314 1.287.06 1.288-.56.003-.623-.572-1.385-1.28-1.698Z",
    fill: "#FFDB69"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.274 27.491c.146.064.265.012.265-.116 0-.127-.118-.284-.264-.349-.146-.064-.264-.012-.265.116 0 .128.119.286.264.349ZM16.106 28.307a1.448 1.448 0 0 0-.318-.198.955.955 0 0 0-.325-.084.52.52 0 0 0-.27.053c-.04.02-.039.082.006.137.02.024.046.045.071.056.03.013.06.015.08.005a.379.379 0 0 1 .198-.04.712.712 0 0 1 .24.061 1.136 1.136 0 0 1 .43.354.2.2 0 0 0 .079.065c.027.01.052.014.073.006.043-.016.046-.074.006-.13a1.623 1.623 0 0 0-.27-.285ZM16.295 27.476c-.147-.064-.264-.012-.266.116-.001.128.118.285.262.349.147.064.266.013.267-.114.002-.128-.117-.286-.263-.35Z",
    fill: "#3E4992"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.705 27.91c-.706-.312-1.285-.06-1.287.563-.002.62.572 1.382 1.279 1.695.707.312 1.287.06 1.288-.56.002-.623-.573-1.386-1.28-1.699Z",
    fill: "#FFDB69"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.455 28.623c0-.128-.117-.285-.262-.349-.146-.065-.265-.012-.265.116 0 .127.117.284.263.348.145.065.264.013.264-.115ZM18.698 29.398c-.167-.073-.303-.09-.303-.038 0 .055.136.16.303.233.168.074.305.09.305.036 0-.052-.137-.156-.305-.231ZM19.213 28.724c-.147-.064-.264-.012-.266.116 0 .127.118.284.264.349.146.064.265.012.265-.116 0-.126-.119-.283-.263-.349Z",
    fill: "#3E4992"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.597 16.042c1.418.703 3.26 1.66 4.217.096.356-.58.996-1.426 1.211-2.044.144-.413.364-1.841 1.17-1.107.293.267.181.755.22 1.092.097-.03.302-.097.383-.04.216.148-.458.594-.664.734-1.57 3.001-1.813 3.93-3.91 4.038-.132.007-1.63-.248-1.945-.356a2.558 2.558 0 0 1-.606-.325c-.325-.225-.35-.63-.706-.842",
    fill: "url(#survey-management-icon_svg__b)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.006 37.824s-.143.43-.185.59c-.026.098.028.364.073.554.03.126.138.227.278.257a1 1 0 0 0 .73-.12l1.956-1.193c.103-.063.138-.187.078-.286l-.052-.09a.397.397 0 0 0-.433-.174c-.441.102-1.264.27-1.555.202-.406-.094-.89.26-.89.26Z",
    fill: "#00AF9B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M.945 36.544s.006 1.264.06 1.44c.054.177.689.171.86-.209.144-.323.224-1.373.224-1.373l-1.144.142Z",
    fill: "url(#survey-management-icon_svg__c)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.489 38.53s-.197.413-.26.567c-.039.095-.019.365.003.558.014.13.108.24.243.286.243.08.512.065.74-.044l2.095-.98c.11-.053.161-.172.115-.277l-.04-.095a.393.393 0 0 0-.409-.218c-.451.054-1.289.137-1.57.038-.393-.136-.917.165-.917.165Z",
    fill: "#00AF9B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.423 37.35s-.108 1.261-.072 1.441c.037.18.672.222.876-.145.173-.31.347-1.352.347-1.352l-1.15.057Z",
    fill: "url(#survey-management-icon_svg__d)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M.24 23.894s.664 4.96.435 6.27c-.436 2.485.101 6.38.101 6.38.493.276 1.007.275 1.412 0 0 0 .636-8.28 1.776-10.038V23.72l-1.517-1.497-1.633-.26c-.498.197-.668 1.446-.575 1.93Z",
    fill: "#2E2E2E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74 23.318s-.26 3.383-.804 6.786c-.512 3.202-1.304 6.403-1.417 7.343a.465.465 0 0 1-.231.344c-.173.105-.451.204-.837.133a.323.323 0 0 1-.268-.275c-.118-1.044-.18-5.807-.177-6.666.004-.971-.918-6.695-.918-6.695l.3-2.326 4.352 1.356Z",
    fill: "#2E2E2E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.414 13.854s2.898 2.21 2.327 3.914c-.839 2.503.644 6.74.658 7.772.001.088-.082.158-.18.146-.191-.02-.467-.16-.478-.784 0 0 .189 1.077-.64 1.358-.828.28-4.373.47-5.632-.373 0 0-1.179-1.33.2-4.61 1.56-3.705-1.539-5.239.384-7.352.653-.716 1.604-.863 3.361-.07Z",
    fill: "#00AF9B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m4.797 12.284-.179 1.57c-.013.123-.118.22-.251.24a1.96 1.96 0 0 1-1.351-.27.47.47 0 0 1-.214-.526l.32-1.158 1.675.144Z",
    fill: "url(#survey-management-icon_svg__e)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.684 9.727s.335 1.978.115 2.501c-.22.523-1.595.763-1.947.607-.352-.155-1.392-1.232-1.448-1.708-.223-1.924 2.003-2.452 3.28-1.4Z",
    fill: "url(#survey-management-icon_svg__f)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.885 11.105c.549.06 3.4-1.276 2.002-1.971-2.27-1.13-5.084.443-5.343 2.572-.148.641-.095 2.503.528 2.982 1.124.685 3.728.147 4.07-.598v.007c-.5-1.168-.903-2.152-.719-3.41",
    fill: "#FF0082"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.899 21.843h-.003a2.054 2.054 0 0 1-.178-.046c-.46-.146-2.175-.48-2.511-.993-.72-1.103-.147-3.846-.948-4.773-.802-.927-1.874-.096-2.075.482-.202.578.665 4.714 1.484 5.618.755.835 3.415.756 4.28.785.113.003.223.02.332.046.2.047.392.068.623.16.385.153.514.686.656.865a.188.188 0 0 0 .058.048c.118.064.27-.015.299-.139.245-1.06-.604-2.014-1.654-2.013-.123.001-.245-.014-.363-.04Z",
    fill: "url(#survey-management-icon_svg__g)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey-management-icon_svg__a",
    x1: 22.659,
    y1: 11.518,
    x2: 13.286,
    y2: 27.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey-management-icon_svg__b",
    x1: 4.18,
    y1: 15.364,
    x2: 11.616,
    y2: 16.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#612909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#AB4904"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey-management-icon_svg__c",
    x1: 0.945,
    y1: 37.25,
    x2: 2.089,
    y2: 37.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey-management-icon_svg__d",
    x1: 3.359,
    y1: 38.055,
    x2: 4.496,
    y2: 38.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey-management-icon_svg__e",
    x1: 2.009,
    y1: 10.129,
    x2: 6.797,
    y2: 19.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey-management-icon_svg__f",
    x1: 2.601,
    y1: 15.997,
    x2: 5.196,
    y2: 6.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "survey-management-icon_svg__g",
    x1: 9.283,
    y1: 20.939,
    x2: 2.761,
    y2: 17.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612909"
  })))));
};
export { SvgSurveyManagementIcon as ReactComponent };
export default __webpack_public_path__ + "39ebbcdb98fd5b98423ed917d62ed21f.svg";